import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import { motion } from 'framer-motion';
import Header2 from '../Header2/Header2';

const Login = () => {
  const [isRegister, setIsRegister] = useState(false);

  return (
    <>
      <Header2 />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="xs">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <Paper
              elevation={10}
              sx={{
                p: 4,
                borderRadius: 4,
                textAlign: 'center',
                backdropFilter: 'blur(10px)',
                background: 'rgba(255, 255, 255, 0.05)',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
              }}
            >
              {/* Title */}
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.5 }}
              >
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                  {isRegister ? 'Create Account' : 'Welcome Back'}
                </Typography>
                <Typography variant="body2" color="gray">
                  {isRegister
                    ? 'Sign up to get started'
                    : 'Please log in to continue'}
                </Typography>
              </motion.div>

              {/* Form Inputs */}
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.5 }}
              >
                {isRegister && (
                  <TextField
                    fullWidth
                    label="Full Name"
                    variant="outlined"
                    margin="normal"
                    sx={textFieldStyles}
                  />
                )}
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  sx={textFieldStyles}
                />
                <TextField
                  fullWidth
                  label="Password"
                  type="password"
                  variant="outlined"
                  margin="normal"
                  sx={textFieldStyles}
                />
                {isRegister && (
                  <TextField
                    fullWidth
                    label="Confirm Password"
                    type="password"
                    variant="outlined"
                    margin="normal"
                    sx={textFieldStyles}
                  />
                )}
              </motion.div>

              {/* Action Button */}
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.3 }}
              >
                <Button fullWidth variant="contained" sx={buttonStyles}>
                  {isRegister ? 'Register' : 'Login'}
                </Button>
              </motion.div>

              {/* Toggle Link */}
              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  color: '#75AD3E',
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                }}
                onClick={() => setIsRegister(!isRegister)}
              >
                {isRegister
                  ? 'Already have an account? Login'
                  : 'Don’t have an account? Register'}
              </Typography>
            </Paper>
          </motion.div>
        </Container>
      </Box>
    </>
  );
};

// Reusable styles
const textFieldStyles = {
  input: { color: 'white' },
  label: { color: 'gray' },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'gray' },
    '&:hover fieldset': { borderColor: '#00ff99' },
    '&.Mui-focused fieldset': { borderColor: '#00ff99' },
  },
};

const buttonStyles = {
  mt: 2,
  py: 1.5,
  fontSize: '1rem',
  fontWeight: 'bold',
  borderRadius: 3,
  background: 'linear-gradient(135deg, #14331D , #75AD3E )',
  '&:hover': { background: '#78a74b' },
};

export default Login;
